document.addEventListener("DOMContentLoaded", () => {
  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const selectors = [
    ".rudra-collections",
    ".rudra-featured",
    ".rudra-story__content",
    ".rudra-story__media",
    ".rudra-why-card",
    ".rudra-testimonial",
    ".rudra-newsletter__inner",
    ".rudra-card-wrap",
    ".rudra-collection-card"
  ];

  const items = document.querySelectorAll(selectors.join(","));

  if (prefersReducedMotion || !("IntersectionObserver" in window)) {
    items.forEach((item) => item.classList.add("is-visible"));
    return;
  }

  items.forEach((item) => item.classList.add("rudra-reveal"));

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.16,
    rootMargin: "0px 0px -40px 0px"
  });

  items.forEach((item) => observer.observe(item));
});
